import React, { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';

import BtnGradient from 'src/components/common/button/BtnGradient';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import Record from './Record';

import { getAPI, postAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';
import { getField } from 'src/common/helper';
import { useNotify } from 'src/context/ContextNotify';

const surgeryDoctorDefine = {
  doctorPrices: [],
  surgery: {}
}
type SugeryDoctorType = {
  doctorPrices: any[];
  surgery: any
};

interface DialogDetailProps {
  open: boolean;
  id: number;
  onClose: (isRefreshList?: boolean) => void;
};

const DialogDoctorFee: React.FC<DialogDetailProps> = (props) => {
  const [datas, setDatas] = useState<SugeryDoctorType>(surgeryDoctorDefine);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const notifyContext = useNotify();

  const handleChange = (index: number, fieldName: string, value: number | null) => {
    let newDoctorPrices = datas.doctorPrices;
    newDoctorPrices[index][fieldName] = value;

    setDatas((prevState) => ({
      ...prevState,
      doctorPrices: newDoctorPrices
    }))
  };

  const getDoctorSurgery = () => {
    try {
      const token = getToken();

      if (!token) {
        throw new Error('Failed to get access token');
      }

      setIsLoading(true);
      getAPI(`/master/surgery-doctor?id=${props.id}&token=${token}`)
        .then((res: any) => {
          if (res.code === 200 && res.data) {
            setDatas({
              doctorPrices: getField(res.data, 'doctor_prices', []),
              surgery: getField(res.data, 'surgery', {})
            })
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    } catch (error) {
      console.error('Failed to fetch data:', error);
      throw error;
    }
  };

  const handleSave = () => {
    try {
      const token = getToken();

      if (!token) {
        throw new Error('Failed to get access token');
      }

      const items = datas.doctorPrices.map((data: any) => {
        return {
          id: getField(data, 'doctorid', null),
          price_pct: getField(data, 'price_pct', null),
          price_monitor_pct: getField(data, 'price_monitor_pct', null)
        }
      });

      const data = {
        id: props.id,
        items
      };

      postAPI(`/master/surgery-doctor-save?token=${token}`, data)
        .then((res: any) => {
          if (res.code === 200) {
            notifyContext.setNotifyMessage({
              show: true,
              message: '保存出来ました。',
              type: 'success',
            });
            props.onClose(true);
          }
          if (res.code === 500 || res.code === 501) {
            notifyContext.setNotifyMessage({
              show: true,
              message: res.msg || 'Failed to post data',
              type: 'error'
            });
          }
        })
        .finally(() => {
        });
    } catch (error) {
      console.error('Failed to fetch data:', error);
      throw error;
    }
  };

  const handleClose = () => {
    props.onClose();
  };

  useEffect(() => {
    if (props.open) {
      getDoctorSurgery();
    }
    // eslint-disable-next-line
  }, [props.open]);

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      sx={{
        '& .MuiDialog-paper': {
          width: '100%',
          maxWidth: '800px',
          m: '0px'
        }
      }}
    >
      <DialogTitle id='scroll-dialog-title' sx={{ p: '24px', pb: '0px' }}>
        <Stack direction={'row'} justifyContent={'space-between'}>
          <Typography sx={{ fontSize: '20px', lineHeight: '24px', fontWeight: 500 }}>
            医師価格設定
          </Typography>
          <IconButton
            aria-label='toggle password visibility'
            edge='end'
            onClick={handleClose}
          >
            <Box
              component={'img'}
              src='/images/ic-close-blue.svg'
              alt='icon eye'
              sx={{ width: '24px', height: '24px' }}
            />
          </IconButton>
        </Stack>
      </DialogTitle>

      <DialogContent
        sx={{
          p: '0px 10px 24px 24px'
        }}
      >
        <Box sx={{ p: '15px' }}>
          <Typography
            component={'label'}
            sx={{
              fontSize: '15px',
              lineHeight: '14px',
              fontWeight: 400
            }}
          >
            {`麻酔 ／ ${getField(datas.surgery, 'surgery', '-')}`}
          </Typography>
        </Box>


        <Stack spacing='10px' sx={{ pr: '14px' }}>
          <Record
            items={datas.doctorPrices}
            surgery={datas.surgery}
            onChange={handleChange}
            isLoading={isLoading}
          />
        </Stack>
      </DialogContent>

      <DialogActions
        style={{
          justifyContent: 'right',
          padding: '16px'
        }}
      >
        <BtnOutlineGradient text='キャンセル' handleButtonClick={handleClose} disabled={isLoading} />
        <BtnGradient text='登録' handleButtonClick={handleSave} disabled={isLoading} />
      </DialogActions>
    </Dialog>
  );
};

export default DialogDoctorFee;
